"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledLabel = _styledComponents.default.span.withConfig({
  displayName: "StyledLabel",
  componentId: "sc-1r95cia-0"
})(["margin-top:", ";margin-right:", ";margin-left:", ";"], (0, _rem.default)(_spacing.default.base * 0.2), function (_ref) {
  var hasBadge = _ref.hasBadge,
      marginRight = _ref.marginRight;
  return hasBadge && marginRight ? (0, _rem.default)(_spacing.default.base) : '0';
}, function (_ref2) {
  var hasBadge = _ref2.hasBadge,
      marginLeft = _ref2.marginLeft;
  return hasBadge && marginLeft ? (0, _rem.default)(_spacing.default.base) : '0';
});

var _default = StyledLabel;
exports.default = _default;